"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _urijs = _interopRequireDefault(require("urijs"));

var _providerEvents = _interopRequireDefault(require("./providerEvents.js"));

var _v = _interopRequireDefault(require("uuid/v4"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function EventBroker() {
  var _handler = null;
  var _lastParams = null;

  var hasValidHandler = function hasValidHandler() {
    return typeof _handler === 'function';
  };

  this.setHandler = function (handler) {
    _handler = handler;

    if (_lastParams && hasValidHandler()) {
      _handler(_lastParams);

      _lastParams = null;
    }
  };

  this.raiseEvent = function (params) {
    var isValidHandler = hasValidHandler();

    if (isValidHandler) {
      _handler(params);
    } else {
      _lastParams = params;
    }
  };
}

var insertElementToHead = function insertElementToHead(element) {
  if (element) {
    if (element.setAttribute) {
      element.setAttribute('data-provider', 'true');
    }

    var head = document.querySelector('head');
    head.insertBefore(element, head.childNodes[0]); // prepend, so it is easier to overwrite
  }
};

var insertCssHrefs = function insertCssHrefs(hrefs) {
  var createCssLink = function createCssLink(href) {
    var cssLink = document.createElement('link');
    cssLink.href = href;
    cssLink.rel = 'stylesheet';
    cssLink.type = 'text/css';
    return cssLink;
  };

  if (hrefs) {
    hrefs.forEach(function (href) {
      return insertElementToHead(createCssLink(href));
    });
  }
};

var communicationToken = (0, _urijs["default"])(window.location.href).search(true).token;
var parent = window.parent;
var refreshCartBroker = new EventBroker();
var onCheckoutHandler = new EventBroker();
var onSaveHandler = new EventBroker();
var itemChanged = new EventBroker();
var mobileItemAction = new EventBroker();
var addToCartRequest = new EventBroker();
var objCallbacks = {};
var styles = null;
window.addEventListener('message', function (event) {
  var _event$data = event.data,
      type = _event$data.type,
      token = _event$data.token,
      payload = _event$data.payload;

  if (communicationToken === token) {
    switch (type) {
      case _providerEvents["default"].callback:
        {
          var callbackPayload = payload.payload;
          var callbackId = payload.callbackId;
          var resolved = payload.resolved;

          if (objCallbacks && objCallbacks[callbackId]) {
            var objCallback = objCallbacks[callbackId];
            var callbackFunc = resolved ? objCallback.resolve : objCallback.reject;

            if (callbackFunc) {
              callbackFunc(callbackPayload);
            }

            delete objCallbacks[callbackId];
          }
        }
        break;

      case _providerEvents["default"].refreshCart:
        refreshCartBroker.raiseEvent(payload);
        break;

      case _providerEvents["default"].css:
        styles = payload.styles;
        removeProviderElements();
        insertCss(createCss(payload.styles));
        insertCssHrefs(payload.hrefs);
        break;

      case _providerEvents["default"].checkout:
        onCheckoutHandler.raiseEvent(payload);
        break;

      case _providerEvents["default"].save:
        onSaveHandler.raiseEvent();
        break;

      case _providerEvents["default"].itemChanged:
        itemChanged.raiseEvent(payload);
        break;

      case _providerEvents["default"].mobileItemClicked:
        mobileItemAction.raiseEvent(payload);
        break;

      case _providerEvents["default"].addToCartRequest:
        addToCartRequest.raiseEvent();
        break;

      default:
        break;
    }
  }
});

function removeProviderElements() {
  if (document.querySelectorAll) {
    var arrProviderElementsElements = document.querySelectorAll('[data-provider="true"]');

    if (arrProviderElementsElements.length) {
      var headElement = document.querySelector('head');
      arrProviderElementsElements.forEach(function (element) {
        headElement.removeChild(element);
      });
    }
  }
}

function createCss(_ref) {
  var title = _ref.title,
      description = _ref.description,
      button = _ref.button,
      background = _ref.background,
      gallery = _ref.gallery;
  var titleFont = gallery && gallery.title && gallery.title.font && gallery.title.font.value;
  var descriptionFont = gallery && gallery.description && gallery.description.font && gallery.description.font.value;
  return "\n    /****** gallery ******/\n      /****** title ******/\n      .gallery-title-font {\n        " + titleFont + "\n      }\n      /****** description ******/\n      .gallery-description-font {\n        " + descriptionFont + "\n      }\n\n    /****** title ******/\n    .shop-title {\n      color: " + title.color + ";\n      " + title.font.value + "\n    }\n    .shop-title-font {\n      " + title.font.value + "\n    }\n    .shop-title-color {\n      color: " + title.color + ";\n    }\n    .background-as-shop-title-color {\n      background-color: " + title.color + ";\n    }\n\n    /****** description ******/\n    .shop-description {\n      color: " + description.color + ";\n      " + description.font.value + "\n    }\n    .shop-description-font {\n      " + description.font.value + "\n    }\n    .shop-description-color {\n      color: " + description.color + ";\n    }\n    .background-as-shop-description-color {\n      background-color: " + description.color + ";\n    }\n    .border-as-shop-description-color {\n      border-color: " + description.color + ";\n    }\n\n    /****** button ******/\n    .shop-button {\n      color: " + button.color + ";\n      background-color: " + button.background + ";\n      " + button.font.value + "\n    }\n    .shop-button-background {\n      background-color: " + button.background + ";\n    }\n    .shop-button-font {\n      " + button.font.value + "\n    }\n    .shop-button-color {\n      color: " + button.color + ";\n    }\n    .background-as-shop-button-color {\n      background-color: " + button.color + ";\n    }\n\n    /****** background ******/\n    .shop-background {\n      background-color: " + background.color + ";\n    }\n    .color-as-shop-background {\n      color: " + background.color + ";\n    }";
}

function insertCss(css) {
  var styleElement = document.createElement('style');
  styleElement.setAttribute('type', 'text/css');
  styleElement.textContent = css;
  insertElementToHead(styleElement);
}

function handleCheckout(handler) {
  onCheckoutHandler.setHandler(handler);
}

function handleSave(handler) {
  onSaveHandler.setHandler(handler);
}

function handleRefreshCart(handler) {
  refreshCartBroker.setHandler(handler);
}

function postMessage(type, payload, resolve, reject) {
  if (payload === void 0) {
    payload = {};
  }

  if (parent && parent.postMessage) {
    var callbackId = null;

    if (resolve) {
      callbackId = (0, _v["default"])();
      objCallbacks[callbackId] = {
        resolve: resolve,
        reject: reject
      };
    }

    parent.postMessage({
      type: type,
      token: communicationToken,
      payload: payload,
      callbackId: callbackId
    }, '*');
  }
}

function validateItemDetails(itemDetails) {
  var isValid = false;

  if (itemDetails) {
    isValid = true;
  }

  return isValid;
}

function sendAddCartItem(itemDetails, metadata, options) {
  if (metadata === void 0) {
    metadata = {};
  }

  if (options === void 0) {
    options = {};
  }

  var uuid = options.uuid || (0, _v["default"])();
  var quantity = options.quantity || 1;
  return new Promise(function (resolve, reject) {
    if (validateItemDetails(itemDetails)) {
      postMessage(_providerEvents["default"].addToCart, {
        itemDetails: itemDetails,
        metadata: metadata,
        uuid: uuid,
        quantity: quantity
      }, resolve, reject);
    } else {
      reject();
    }
  });
}

function sendUpdateItem(uuid, payload) {
  postMessage(_providerEvents["default"].updateCartItem, {
    uuid: uuid,
    metadata: payload.metadata,
    quantity: payload.quantity
  });
}

function sendClearCart(uuid, payload) {
  postMessage(_providerEvents["default"].clearCart, {});
}

function sendRemoveItem(uuid) {
  postMessage(_providerEvents["default"].removeFromCart, {
    uuid: uuid
  });
}

function home(options) {
  postMessage(_providerEvents["default"].backHome, options);
}

function sendsSetHeight(height) {
  postMessage(_providerEvents["default"].setHeight, {
    height: height
  });
}

function sendSelectPhoto() {
  return new Promise(function (resolve, reject) {
    postMessage(_providerEvents["default"].selectPhoto, {}, resolve);
  });
}

function sendSelectFile() {
  return new Promise(function (resolve, reject) {
    postMessage(_providerEvents["default"].selectFile, {}, resolve);
  });
}

function sendNavigateToUrl(url) {
  postMessage(_providerEvents["default"].navigateToUrl, {
    url: url
  });
}

function sendClose() {
  postMessage(_providerEvents["default"].close);
}

function sendSaveCompleted() {
  postMessage(_providerEvents["default"].saveCompleted);
}

function onItemChanged(callback) {
  itemChanged.setHandler(callback);
}

function onMobileItemAction(callback) {
  mobileItemAction.setHandler(callback);
}

function onAddToCart(callback) {
  addToCartRequest.setHandler(callback);
}

function checkout(options) {
  postMessage(_providerEvents["default"].goToCheckout, options);
}

function manage(options) {
  if (options === void 0) {
    options = {};
  }

  postMessage(_providerEvents["default"].openManege, {
    options: options
  });
}

function gotoPricing(options) {
  return new Promise(function (resolve, reject) {
    postMessage(_providerEvents["default"].openPricing, {}, resolve, reject);
  });
}

function setDefaultPrice(data) {
  postMessage(_providerEvents["default"].setDefaultPrice, data);
}

function getSiteInfo() {
  return new Promise(function (resolve, reject) {
    postMessage(_providerEvents["default"].getSiteUrls, {}, resolve, reject);
  });
}

function getSiteProperties() {
  return new Promise(function (resolve, reject) {
    postMessage(_providerEvents["default"].getSiteProperties, {}, resolve, reject);
  });
}

function sendOpenModal(name, options) {
  return new Promise(function (resolve, reject) {
    postMessage(_providerEvents["default"].openModal, {
      name: name,
      options: options
    }, resolve, reject);
  });
}

function sendGetCartItems(options) {
  if (options === void 0) {
    options = {};
  }

  return new Promise(function (resolve, reject) {
    postMessage(_providerEvents["default"].getCartItems, {
      options: options
    }, resolve, reject);
  });
}

function getStyles() {
  var returnPromise = null;

  if (styles) {
    returnPromise = Promise.resolve(styles);
  } else {
    returnPromise = new Promise(function (resolve, reject) {
      postMessage(_providerEvents["default"].getStyles, {}, resolve, reject);
    });
  }

  return returnPromise;
}

function setMobileProductData(type, data) {
  postMessage(_providerEvents["default"].setMobileProductData, {
    type: type,
    data: data
  });
  return Promise.resolve();
}

function gotoPayments() {
  postMessage(_providerEvents["default"].gotoPayments);
  return Promise.resolve();
}

postMessage(_providerEvents["default"].sdkReady);
var cartOperations = {
  updateItem: sendUpdateItem,
  removeItem: sendRemoveItem,
  getCartItems: sendGetCartItems,
  clearCart: sendClearCart
};
var _default = {
  pricing: {
    manage: manage,
    close: sendClose,
    openFile: sendSelectFile,
    getSiteInfo: getSiteInfo,
    onSave: handleSave,
    saveCompleted: sendSaveCompleted
  },
  manage: {
    gotoPricing: gotoPricing,
    close: sendClose,
    openMedia: sendSelectPhoto,
    openFile: sendSelectFile,
    getSiteInfo: getSiteInfo,
    getSiteProperties: getSiteProperties,
    gotoPayments: gotoPayments,
    onSave: handleSave,
    saveCompleted: sendSaveCompleted
  },
  shop: {
    openModal: sendOpenModal,
    addToCart: sendAddCartItem,
    setHeight: sendsSetHeight,
    onItemChanged: onItemChanged,
    onAddToCart: onAddToCart,
    checkout: checkout,
    home: home,
    close: sendClose,
    setDefaultPrice: setDefaultPrice,
    setMobileProductData: setMobileProductData,
    onMobileItemAction: onMobileItemAction,
    cart: cartOperations
  },
  checkout: {
    home: home,
    getSiteInfo: getSiteInfo,
    cart: cartOperations
  },
  thankyou: {
    setHeight: sendsSetHeight,
    home: home,
    cart: cartOperations
  },
  cart: {
    openModal: sendOpenModal,
    getSiteInfo: getSiteInfo,
    home: home,
    checkout: checkout,
    removeItem: sendRemoveItem,
    onRefreshCart: handleRefreshCart,
    onCheckout: handleCheckout,
    updateItem: sendUpdateItem,
    clearCart: sendClearCart
  },
  modal: {
    close: sendClose,
    addToCart: sendAddCartItem,
    updateItem: sendUpdateItem,
    removeItem: sendRemoveItem,
    getCartItems: sendGetCartItems,
    cart: cartOperations
  },
  getStyles: getStyles
};
exports["default"] = _default;